<template>
  <div
    :id="modalId"
    :class="classes"
    :style="this.styles"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div v-if="data" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Editar Grupo</h5>
          <button type="button" class="close" @click="hide" aria-label="Close">
            <span class="material-symbols-outlined">close</span>
          </button>
        </div>
        <form @submit.prevent="save" class="form-horizontal">
          <div class="modal-body">
            <div class="form-body">
              <div class="form-group row">
                <label class="control-label col-12 text-left-m"
                  >{{$tc('generic-str.name', 1)}}</label
                >
                <div class="col-12">
                  <input v-model="form.name" type="text" class="form-control" />
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label col-12 text-left-m"
                  >{{$t('departments.data-infos.lbl-description')}}</label
                >
                <div class="col-12">
                  <textarea
                    v-model="form.description"
                    type="text"
                    class="form-control"
                    rows="10"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <button type="button" class="btn btn-outline-primary" @click="hide">
              {{$t('generic-str.cancel')}}
            </button>
            <button
              :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
              :disabled="isSending"
              type="submit"
              class="btn btn-primary"
            >
              {{$t('generic-str.save')}}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ContactService from '@/services/contact.service';
import Modal from '@/mixins/Modal';

export default {
  mixins: [Modal],
  props: ['id'],
  data() {
    return {
      groups: [],
      isSending: false,
    };
  },
  methods: {
    save() {
      this.isSending = true;
      ContactService.editGroup(this.form).then(
        () => {
          this.hide();
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: 'Grupo salvo',
            type: 'success',
          });
          this.$emit('sent');
          this.isSending = false;
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
            content: error.message,
            type: 'danger',
          });
          this.isSending = false;
        },
      );
    },
  },
};
</script>
<style scoped lang="scss">
.form-horizontal {
  height: 60vh;
}
.modal-body {
  padding: 1rem 4rem;
}
.modal-footer {
  .btn-outline-primary {
    margin-right: 6rem;
  }
}
</style>
